import React from 'react';

export interface ShimmerBoxProps {
  className?: string;
  style?: React.CSSProperties;
  'data-testid'?: string;
}

const ShimmerBox: React.FC<ShimmerBoxProps> = ({
  className = '',
  style,
  'data-testid': testId,
}) => (
  <div
    className={['wday-shimmer', className].filter(Boolean).join(' ')}
    style={style}
    data-testid={testId}
    aria-hidden
  />
);

export default ShimmerBox;
